import PageContent from './pageContent';
// import CheckoutSession from './checkoutSession';
import { extend, override } from 'flarum/common/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import IndexPage from 'flarum/forum/components/IndexPage';
import TagsPage from 'flarum/forum/components/TagsPage';
import Page from 'flarum/common/components/Page';
import UserPage from 'flarum/forum/components/UserPage';
import SettingsPage from 'flarum/forum/components/SettingsPage';


app.initializers.add('morphdev/stripe-subscription', () => {
  app.routes['morphdev.stripe-subscription'] = { path: '/subscribe', component: PageContent };
});


// extend(DiscussionList.prototype, 'oninit', function(items) {
//   // redirect unsubscribed users
//   var groups = app.store.data.groups;
//   var activatedId = Object.entries(groups).find(g => g[1].data.attributes.nameSingular == 'activated')[0]

//   if(app.session.user.data.relationships.groups.data.length <= 0 || app.session.user.data.relationships.groups.data.find(d => d.id === activatedId).id !== activatedId){
//     m.route.set('/subscribe')
//   }
// });


// extend(IndexPage.prototype, 'oninit', function(items) {
//   // redirect unsubscribed users
//   var groups = app.store.data.groups;
//   var activatedId = Object.entries(groups).find(g => g[1].data.attributes.nameSingular == 'activated')[0]

//   if(app.session.user.data.relationships.groups.data.length <= 0 || app.session.user.data.relationships.groups.data.find(d => d.id === activatedId).id !== activatedId){
//     m.route.set('/subscribe')
//   }
// });


extend(Page.prototype, 'oninit', function(items) {
  // redirect unsubscribed users
  if(app.session.user){
  var groups = app.store.data.groups;
  var userGroups = app.session.user.data.relationships.groups.data;
  var isAdmin = Object.entries(userGroups).find(g => g[1].id == 1);
  var activatedId = Object.entries(groups).find(g => g[1].data.attributes.nameSingular == 'activated')[0];

  if(!isAdmin){
    if(app.session.user.data.relationships.groups.data.length <= 0 || app.session.user.data.relationships.groups.data.find(d => d.id === activatedId).id !== activatedId){
      if(app.current.data.routeName !== 'settings' && app.current.data.routeName !== 'user.posts' && app.current.data.routeName !== 'fof-masquerade-configure-profile'){
        m.route.set('/subscribe')
      }
    }
  }
  } else {
      if(app.current.data.routeName === '/all' || app.current.data.routeName === '/tags' || app.current.data.routeName === 'index' || app.current.data.routeName === 'tags'){
      m.route.set('/welcome')
    }
  }  
});

extend(SettingsPage.prototype, 'accountItems', function(items){
  // Add button for Stripe portal to settings
  var stripeLogin = (
    <li class="item-changeEmail">
        <form action="/create-portal-session" method="POST">
          <button id="portal-button" class="Button" type="submit" >Manage Subscription</button>
        </form>
    </li>
  )
  items.add('account', stripeLogin);
})
